export default "/images/7a3bb6134ecac6cc9b85ded3217762d8.avif";